import React from 'react';
import { ArrowUpRight, Clock, MapPin } from 'lucide-react';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { brand, visitInfo } from '../../data/site';
import { LocationMap } from '../LocationMap';
export function MapScene() {
  return <CinematicScene id="map" backgroundSlot={<LocationMap data-id="element-83" data-mp="3tclb8lormr5q" />} scrim="left" height="standard" data-id="element-82" data-mp="3tbtfnav64tfg">
      <div className="flex h-full w-full items-center" data-id="element-84" data-mp="kvzzwy8nvlzg">
        <div className="w-full px-6 md:px-16 lg:px-24" data-id="element-85" data-mp="kym7gxvjy1ho">
          <Reveal className="pointer-events-auto w-full max-w-md" data-id="element-86" data-mp="pu1izj637lax">
            <div className="rounded-sm border border-hair bg-ink/80 p-8 backdrop-blur-md md:p-10" data-id="element-87" data-mp="c4hk4ofmn86w">
              <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-brass" data-id="element-88" data-mp="g51g3oogs5rg">
                The Corner
              </p>
              <h2 className="font-display text-[1.9rem] font-normal leading-[1.15] text-cream md:text-4xl" data-id="element-89" data-mp="13tkr4bywewn8">
                FIND US ON WABASH.
              </h2>
              <p className="mt-5 font-mono text-[11.5px] leading-[1.9] text-stone" data-id="element-90" data-mp="149vm0uz32pd0">
                {visitInfo.crossStreet}
              </p>

              <dl className="mt-8 space-y-5 border-t border-hair pt-7" data-id="element-91" data-mp="zd56c8r6xvs4">
                <div className="flex items-start gap-3" data-id="element-92" data-mp="1e19ptey2ibby">
                  <MapPin className="mt-0.5 h-3.5 w-3.5 flex-none text-brass" aria-hidden="true" data-id="element-93" data-mp="199i0f7qnebne" />
                  <div data-id="element-94" data-mp="1mzbmjiarqhtf">
                    <dt className="mb-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-brass" data-id="element-95" data-mp="1n2zfaf8e3073">
                      Address
                    </dt>
                    <dd className="font-mono text-[11.5px] leading-[1.8] text-cream" data-id="element-96" data-mp="1wy1419yr6095">
                      {visitInfo.address}
                    </dd>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-97" data-mp="2m49v98xegae">
                  <Clock className="mt-0.5 h-3.5 w-3.5 flex-none text-brass" aria-hidden="true" data-id="element-98" data-mp="3trci2rx1z4j6" />
                  <div data-id="element-99" data-mp="1xpsk0ykiu15f">
                    <dt className="mb-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-brass" data-id="element-100" data-mp="1xqamwe1ovdmb">
                      Hours
                    </dt>
                    <dd className="font-mono text-[11.5px] leading-[1.8] text-stone" data-id="element-101" data-mp="26nuqhtn0xm03">
                      {visitInfo.hours.map(line => <span key={line} className="block" data-id="element-102" data-mp="2blmj6pvhtc5c">
                          {line}
                        </span>)}
                    </dd>
                  </div>
                </div>
              </dl>

              <a href={visitInfo.directionsUrl} target="_blank" rel="noreferrer" className="group mt-8 inline-flex items-center gap-2.5 border-b border-brass-dim pb-2 font-mono text-[10.5px] uppercase tracking-[0.2em] text-brass transition-colors hover:border-cream hover:text-cream" data-id="element-103" data-mp="2qcddc4kk4nbm">
                Open in Google Maps
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-104" data-mp="3eh4ku3767n1n" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      <footer className="absolute inset-x-0 bottom-8 px-6 md:px-16 lg:px-24" data-id="element-105" data-mp="30hbtc5ntl2sm">
        <Reveal delay={0.3} className="pointer-events-auto rounded-sm bg-ink/70 px-4 py-3 backdrop-blur-sm md:bg-transparent md:px-0 md:py-0 md:backdrop-blur-none" data-id="element-106" data-mp="11oyhzzcbxlt">
          <div className="flex flex-col items-center gap-4 border-t border-hair pt-6 font-mono text-[9.5px] uppercase tracking-[0.15em] text-stone md:flex-row md:justify-between" data-id="element-107" data-mp="3nh9pw6ow69cn">
            <span className="font-display text-sm tracking-[0.18em] text-cream" data-id="element-108" data-mp="3jdlibo09fdre">
              {brand.name}
            </span>
            <span data-id="element-109" data-mp="f1q0jircdb2v">{brand.copyright}</span>
            <span className="text-brass" data-id="element-110" data-mp="f0ocmdp88u3q">{brand.social}</span>
          </div>
        </Reveal>
      </footer>
    </CinematicScene>;
}